import { render } from "./VehicleTypeForm.vue?vue&type=template&id=1c68eab2"
import script from "./VehicleTypeForm.vue?vue&type=script&lang=js"
export * from "./VehicleTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__